import { useNotifications } from 'hooks/useNotifications';

import { useColumns } from 'data/tableData/catalogue/notificationsColumns';

import { Table } from 'components/Table';

import * as S from './List.styles';

export function List(): React.ReactElement {
  const { notifications, refetchNotifications, isLoading } = useNotifications();
  const columns = useColumns(refetchNotifications);

  return (
    <div>
      <S.CreateWrapper>
        <S.Create iconLeft="FiPlus" scale="lg" asLink to="new" motive="addNew">
          Add new Notification
        </S.Create>
      </S.CreateWrapper>
      <Table
        tableName="notifications"
        isLoading={isLoading}
        columns={columns}
        data={notifications}
        hasPagination
        autoResetPage
      />
    </div>
  );
}
